<template>
  <div class="root">
    <el-form ref="form" :model="form" label-width="177px">
      <el-form-item label="区 域：" required>
        <el-cascader :options="options" :props="defaultProps" clearable :popper-append-to-body='false'
          v-model="form.village" style="width: 100%;"></el-cascader>
      </el-form-item>
      <el-form-item label="交易形式：">
        <span class="zhuanrang">{{ form.type == 1 ? "转出" : "受让" }}</span>
      </el-form-item>
      <el-form-item label="项目名称：" required>
        <el-input v-model="form.projectname" style="width: 100%;"></el-input>
      </el-form-item>
      <el-form-item label="转出期限：" required>
        <label slot="label">{{
          form.type == 1 ? "转出期限：" : "承包期限："
        }}</label>
        <el-input v-model="form.outyears" style="width: 100%;"></el-input>
      </el-form-item>
      <el-form-item label="面积/数量：" required>
        <el-input v-model="form.area" style="width: 100%;"></el-input>
      </el-form-item>
      <el-form-item label="转出底价：" required>
        <label slot="label">{{
          form.type == 1 ? "转出价格：" : "接受价格："
        }}</label>
        <el-input v-model="form.listingprice" style="width: 100%;"></el-input>
      </el-form-item>
      <el-form-item label="联  系  人：" required>
        <el-input v-model="form.linkman" style="width: 100%;"></el-input>
      </el-form-item>
      <el-form-item label="联系电话：" required>
        <el-input v-model="form.linkphone" style="width: 100%;"></el-input>
      </el-form-item>
      <el-form-item label="电子邮箱：" required>
        <el-input v-model="form.email" style="width: 100%;"></el-input>
      </el-form-item>
      <!-- <el-form-item label="联系地址：">
        <el-input v-model="form.lianxidizhi" style="width:600px;"></el-input>
      </el-form-item> -->
      <el-form-item label="项目简况：" required>
        <el-input type="textarea" v-model="form.remark"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">
          <img src="../assets/img/按钮.png" alt />
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getDeptTree } from '@/api/意向转让'
import request from '@/util/request';
export default {
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label",
        value: 'id',
        emitPath: false,
      },
      form: {
        projectname: "",
        email: "",
        linkman: "",
        linkphone: "",
        listingprice: "",
        area: "",
        outyears: "",
        village: "",
        remark: "",
        type: 1,
      },
      // 乡镇数组
      options: [],
      // 村数组
      options1: [],
    };
  },
  created() {
    // 更改转出受让
    this.form.type = this.$route.query.id;

    this.form.timestamp = this.timestamp;
    this.form.random = this.numRandom;
    this.form.sign = this.mainSign;

    // 获取乡镇信息
    // let url = "ditudaohang";
    // console.log("乡镇信息");
    // console.log(this.ajax_id(url).data);
    // this.options = this.ajax_id(url).data;
    getDeptTree().then(res => {
      console.log('下拉框组织架构:', res)
      this.options = res.data.data[0].children
    })
    console.log(this.options)
  },
  mounted() { },
  computed: {},
  watch: {},
  methods: {
    onSubmit() {
      console.log(this.form);
      // 提交项目咨询
      let url = "yixiangxinxifabu";
      if (
        this.form.projectname &&
        this.form.email &&
        this.form.linkman &&
        this.form.linkphone &&
        this.form.area &&
        this.form.outyears &&
        this.form.village &&
        this.form.remark &&
        this.form.listingprice
      ) {
        let reg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/; //正则表达式定义手机号正确格式
        let regPhone = new RegExp(reg);
        let reg1 =
          /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/; //正则表达式定义邮箱正确格式
        let regEmail = new RegExp(reg1);
        if (!regPhone.test(this.form.linkphone)) {
          this.$message({
            message: "请输入正确的手机号",
            type: "warning",
          });
        } else if (!regEmail.test(this.form.email)) {
          this.$message({
            message: "请输入正确的邮箱号",
            type: "warning",
          });
        } else {
          request({
            url: '/base/desired',
            method: 'post',
            data: this.form,
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
          }).then(res => {
            // 注册提示
            if (res.data.code == 200) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.form = {
                projectname: "",
                email: "",
                linkman: "",
                linkphone: "",
                listingprice: "",
                area: "",
                outyears: "",
                village: "",
                remark: "",
                type: this.form.type,
              };

              this.$router.back();
            } else {
              this.$message({
                message: "提交失败",
                type: "error",
              });
            }
          })
        }
      } else {
        this.$message({
          message: "请输入必填项",
          type: "warning",
        });
      }

    },
  }
}
</script>

<style scoped>
.el-select-dropdown__item.selected {
  color: #606266 !important;
  font-weight: 400;
}

.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 30px;
  padding: 55px 260px 80px 260px;
  width: 67%;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  zoom: 1.4;
  transform: scale(0.8, 0.8);
  margin-top: -130px;
}

.root>>>.el-form-item__label {
  font-size: 24px;
}

.root>>>.el-form-item__content {
  font-size: 24px;
}

.root>>>.el-input {
  font-size: 24px;
}

.root>>>.el-input__inner {
  height: 50px;
  line-height: 50px;
}

.root>>>.el-textarea {
  font-size: 24px;
}

.root>>>.el-select-dropdown__item {
  font-size: 24px;
}

/* .el-form-item /deep/ .el-form-item__label {
  height: 40px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #333333;
}

.el-form-item /deep/ .el-input__inner {
  height: 40px;
}

.el-form-item {
  margin-bottom: 36px;
} */

.el-textarea /deep/ .el-textarea__inner {
  height: 300px;
}

.el-button {
  display: block;
  padding: 0;
  margin: 0 auto;
}

.zhuanrang {
  width: auto;
  height: 40px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #333333;
  letter-spacing: 5px;
}
</style>